import { render, staticRenderFns } from "./CertificatesDetails.vue?vue&type=template&id=2d8c0c7d&scoped=true"
import script from "./CertificatesDetails.vue?vue&type=script&lang=js"
export * from "./CertificatesDetails.vue?vue&type=script&lang=js"
import style0 from "./CertificatesDetails.vue?vue&type=style&index=0&id=2d8c0c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c0c7d",
  null
  
)

export default component.exports